import "core-js/modules/es6.regexp.search.js";
import "core-js/modules/es6.regexp.split.js";
export function openAuditPanel(_ref) {
  var commit = _ref.commit;
  commit('SET_OPEN', true);
}
export function closeAuditPanel(_ref2) {
  var dispatch = _ref2.dispatch;
  // Remove the hash
  history.pushState('', document.title, window.location.pathname + window.location.search);
  dispatch('auditHashHandler');
}

/**
 * Handle Audit panel by hash in the URL.
 *
 * @param commit
 * @param dispatch
 * @param getters
 */
export function auditHashHandler(_ref3) {
  var commit = _ref3.commit,
    dispatch = _ref3.dispatch,
    getters = _ref3.getters;
  var hash = window.location.hash;
  var regex = /^#audit(\/\d+)?$/;

  // If URL has audit/? hash...
  if (regex.test(hash)) {
    var id = parseInt(hash.split('/').pop());
    // Check if there's an ID in the hash...
    if (id) {
      // If it's there show Audit entry...
      dispatch('audits/getEntry', id, {
        root: true
      });
    } else {
      // Else dismiss entry and show Audit list
      dispatch('audits/dismissEntry', id, {
        root: true
      });
    }
    commit('SET_OPEN', true);
  } else if (getters.isOpen) {
    // Close it no hash and if it's open
    commit('SET_OPEN', false);
  }
}